import { EmailRegex, ZipRegex } from "../../../../constants";
import { isValidPhoneNumber } from "../../../../utils";

export const createImportLeadFromValidation = () => {
    const emailAddressRules = {
        validate: (value: string) => {
            // Empty is allowed
            if (!value.trim()) return true;
            // Otherwise must match EmailRegex
            return EmailRegex.test(value) || "Keine gültige E-Mail-Adresse.";
        }
    };

    const mobileNumberRules = {
        validate: (value: string) => {
            // Empty is allowed
            if (!value.trim()) return true;
            // Otherwise must pass phone validation
            return isValidPhoneNumber(value) || "Keine gültige Telefonnummer.";
        }
    };

    const zipCodeRules = {
        validate: (value: string) => {
            // Empty is allowed
            if (!value.trim()) return true;
            // Otherwise must match ZipRegex
            return ZipRegex.test(value) || "Keine gültige PLZ.";
        }
    };

    const ageRules = {
        validate: (value: string | undefined) => {
            if (value === undefined || value === null) return true;
            const num = Number(value);
            if (isNaN(num)) return "Bitte geben Sie eine gültige Zahl ein.";
            if (num < 0) return "Das Alter darf nicht kleiner als 0 sein.";
            if (num > 150) return "Das Alter darf nicht größer als 150 sein.";
            return true;
        }
    };

    return {
        emailAddressRules,
        mobileNumberRules,
        zipCodeRules,
        ageRules
    };
};
